import { CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';

import {Router} from '@angular/router';

@Injectable()
export class LoginGuard implements CanActivate {

  constructor(
  	private router: Router
  	) {}

  canActivate() {
  	let notExpired = false;
  	try {
	  	notExpired = localStorage.getItem('_user_token')?true: false;
	  	if(!notExpired) {
	  		throw 'TOKEN EXPIRED';
	  	}
    } catch(e) {
    	this.router.navigate(['/login']);
  	}
    return notExpired;
  }
}


// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/guards/login-guard.ts